import InequalityFilterRow from './InequalityFilterRow';
import { action, makeObservable } from 'mobx';
import _ from 'lodash';

class NumericInequalityFilterRow extends InequalityFilterRow {
  constructor(other) {
    super();

    this.value = '0';
    this.range = {
      lower_bound: '0',
      upper_bound: '0'
    };

    makeObservable(this, {
      parseValue: action
    });

    this.merge(other);
  }

  parseValue(value) {
    value = value.replace(/[^0-9\\.]+/g, '').replace(/^0+/, '').replace(/\./, '');

    if (_.isEmpty(value)) return '0';

    return value;
  }
}

export default NumericInequalityFilterRow;
